import { StyledContainer } from "app/layout/Container";
import { PageHeader, PageHeaderType } from "app/layout/PageHeader";
import { ModuleAccess } from "app/practices/moduleAccess";

export const AvailableFeaturesPage = () => (
    <StyledContainer>
        <PageHeader title="Available features" type={PageHeaderType.ListPage} />
        <ModuleAccess />
    </StyledContainer>
);
